module.exports = __webpack_public_path__ + "a8fd64ebbb9061509938ed894869efd4.png";